export const NO_JOB_POSTINGS_MESSAGE = "You dont have any postings yet";

export const MY_JOB_POSTINGS_TITLE = "My Job Postings";
